export var rootState = {
    token: "",
    loginModel: null,
    menuList: [],
    regionTree: [],
    config: null,
    isErp: '',
    homeShow: true,
    typeList: [],
    serviceData: {},
    serviceFlag: true,
    openedCodeData: {},
    ediStatus: false,
    canSelectBatch: 0,
    canSendEmail: 0,
    allSettingScale: []
};
